export const BANNER_FONTS = ["Great Vibes", "Parisienne", "Allura", "Cinzel", "Playfair Display", "Cormorant Garamond", "Montserrat"];

export const BANNER_THEMES = [
  { theme: "classic-romance", label: "Classic Romance", headline_font: "Cormorant Garamond", names_font: "Great Vibes", subtitle_font: "Cormorant Garamond", color: "#FFFFFF", accent: "#FFFFFF" },
  { theme: "black-tie", label: "Black Tie", headline_font: "Cinzel", names_font: "Playfair Display", subtitle_font: "Cormorant Garamond", color: "#FFFFFF", accent: "#E7CF9A" },
  { theme: "garden-script", label: "Garden Script", headline_font: "Montserrat", names_font: "Parisienne", subtitle_font: "Cormorant Garamond", color: "#FFF8EC", accent: "#F3E3C3" },
  { theme: "old-hollywood", label: "Old Hollywood", headline_font: "Cinzel", names_font: "Allura", subtitle_font: "Playfair Display", color: "#F7E7CE", accent: "#C8A96B" },
  { theme: "modern-minimal", label: "Modern Minimal", headline_font: "Montserrat", names_font: "Cinzel", subtitle_font: "Montserrat", color: "#FFFFFF", accent: "#FFFFFF" },
];

const ff = (f, fallback) => (f ? `'${f}', ${fallback}` : undefined);

// Inline styles for the banner headline / names / subtitle from the couple's banner_style.
export function bannerText(st) {
  const s = st || {};
  return {
    headline: { fontFamily: ff(s.headline_font, "serif"), color: s.accent || undefined },
    names: { fontFamily: ff(s.names_font, "cursive"), color: s.color || undefined },
    subtitle: { fontFamily: ff(s.subtitle_font, "serif"), color: s.color || undefined },
  };
}
